<template>
  <nav class="bg-neutral-900 text-white flex justify-between pr-2 min-h-10">
    <div class="flex items-center gap-1 md:gap-2">
      <WorkspaceButton v-if="isLoggedIn" />
      <div class="hidden sm:flex">
        <Breadcrumb v-if="isProjectLoaded" />
      </div>
      <div class="sm:hidden">
        <MobileLeftNav />
      </div>
      <Protect
        v-if="isLoggedIn || isPublicEnabled"
        :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_READ]"
        :roles="['editor', 'viewer']"
      >
        <PlayButton />
      </Protect>

      <div class="hidden sm:flex items-center md:-ml-2">
        <Protect
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_EDIT]"
          :roles="['editor']"
        >
          <Settings />
        </Protect>
        <Protect
          v-if="isLoggedIn"
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_EXPORT]"
          :roles="['editor']"
        >
          <ExportButton />
        </Protect>
        <Protect
          v-if="isParticipant || isLoggedIn"
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_READ]"
          :roles="['viewer', 'editor']"
        >
          <div class="ml-2">
            <ShareButton />
          </div>
        </Protect>
      </div>
    </div>
    <div class="flex items-center gap-2">
      <div class="sm:hidden">
        <MobileRightNav />
      </div>
      <div class="hidden sm:inline-flex items-center">
        <Collaborators />
        <ProjectLimit v-if="isProjectItemsLimited && isLoggedIn" />
        <Protect
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_COMMENT]"
          :roles="['editor', 'viewer']"
        >
          <CommentsButton />
        </Protect>
        <Protect
          v-if="isLoggedIn || isPublicEnabled"
          :permissions="[SYS_PERMISSIONS.SYS_PROJECTS_READ]"
          :roles="['editor', 'viewer']"
        >
          <SearchButton />
        </Protect>
      </div>
      <ProfileMenu v-if="isLoggedIn" />
    </div>
  </nav>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

import { SYS_PERMISSIONS } from '@/constants.js';
import Protect from '@/hoc/Protect.vue';

import { usePremiumFeature } from '@/composables/usePremiumFeature.js';
import WorkspaceButton from './components/WorkspaceButton.vue';
import Breadcrumb from './components/Breadcrumb.vue';
import PlayButton from './components/PlayButton.vue';
import Settings from './components/Settings.vue';
import ExportButton from './components/ExportButton.vue';
import ShareButton from './components/ShareButton.vue';
import CommentsButton from './components/CommentsButton.vue';
import Collaborators from './components/Collaborators.vue';
import SearchButton from './components/SearchButton.vue';
import ProfileMenu from '../board/ProfileMenu.vue';
import ProjectLimit from './components/ProjectLimit.vue';
import MobileLeftNav from './components/MobileLeftNav.vue';
import MobileRightNav from './components/MobileRightNav.vue';

const store = useStore();

const isLoggedIn = computed(() => store.getters['user/account/getIsLoggedIn']);

const isPublicEnabled = computed(
  () => store.getters['project/getPublicLink'] !== null
);

const isProjectLoaded = computed(
  () => store.getters['application/appStates/getIsProjectLoaded']
);

const isParticipant = computed(
  () => store.getters['project/users/amIParticipant']
);

const { isLimited: isProjectItemsLimited } = usePremiumFeature({
  feature: 'project_items',
});
</script>
